import type { SgsInventoryDiscrepancyResolutionKind } from "./inventoryDiscrepancyApi";

export type ApproveResolutionKind = Extract<
  SgsInventoryDiscrepancyResolutionKind,
  "adjustment" | "wastage" | "prototype"
>;

export function approveResolutionOptionLabel(
  kind: ApproveResolutionKind,
  signedQuantity: number,
): string {
  const isNegative = signedQuantity < 0;
  switch (kind) {
    case "adjustment":
      return isNegative ? "Adjustment (−)" : "+ Adjustment";
    case "wastage":
      return isNegative ? "Wastage (−)" : "Wastage";
    case "prototype":
      return isNegative ? "Prototype (−)" : "Prototype";
    default: {
      const _exhaustive: never = kind;
      return _exhaustive;
    }
  }
}

export function approveResolutionOptionHoverHint(
  kind: ApproveResolutionKind,
  signedQuantity: number,
): string | null {
  if (signedQuantity >= 0) {
    return null;
  }
  switch (kind) {
    case "adjustment":
      return "Material was lost or never supposed to be there";
    case "wastage":
      return "Material was broken or QC failed";
    case "prototype":
      return "Material was issued to engineering";
    default: {
      const _exhaustive: never = kind;
      return _exhaustive;
    }
  }
}
